// Maps legacy/renamed timezone identifiers (as returned by browsers via ICU/CLDR) to
// their current canonical IANA names.  Every right-hand value is a zone present in
// zone1970.tab (aion-identity-service), which is what the backend accepts.
export const timeZoneAliases: Record<string, string> = {
  // Asia — renamed canonical cities
  'Asia/Calcutta': 'Asia/Kolkata', // India — renamed 2001
  'Asia/Katmandu': 'Asia/Kathmandu', // Nepal — renamed 1993
  'Asia/Rangoon': 'Asia/Yangon', // Myanmar — renamed 2016
  'Asia/Ulan_Bator': 'Asia/Ulaanbaatar', // Mongolia
  'Asia/Saigon': 'Asia/Ho_Chi_Minh', // Vietnam
  'Asia/Thimbu': 'Asia/Thimphu', // Bhutan
  'Asia/Ashkhabad': 'Asia/Ashgabat', // Turkmenistan
  'Asia/Dacca': 'Asia/Dhaka', // Bangladesh
  'Asia/Macao': 'Asia/Macau', // Macau
  'Asia/Ujung_Pandang': 'Asia/Makassar', // Indonesia
  'Asia/Chongqing': 'Asia/Shanghai', // China (Beijing Time)
  'Asia/Harbin': 'Asia/Shanghai', // China (Beijing Time)
  'Asia/Kashgar': 'Asia/Urumqi', // China (Xinjiang Time)
  'Asia/Istanbul': 'Europe/Istanbul', // Turkey — moved from Asia/ to Europe/ namespace

  // Europe — renamed canonical cities / namespace moves
  'Europe/Kiev': 'Europe/Kyiv', // Ukraine — renamed 2022
  'Europe/Nicosia': 'Asia/Nicosia', // Cyprus — moved from Europe/ to Asia/ namespace
  'Europe/Tiraspol': 'Europe/Chisinau', // Transnistria → Moldova

  // America — renamed canonical cities
  'America/Godthab': 'America/Nuuk', // Greenland — renamed 2020

  // America/Argentina — pre-2000 short forms (before hierarchical structure was added)
  'America/Buenos_Aires': 'America/Argentina/Buenos_Aires',
  'America/Argentina/ComodRivadavia': 'America/Argentina/Catamarca',
  'America/Catamarca': 'America/Argentina/Catamarca',
  'America/Cordoba': 'America/Argentina/Cordoba',
  'America/Rosario': 'America/Argentina/Cordoba',
  'America/Jujuy': 'America/Argentina/Jujuy',
  'America/Mendoza': 'America/Argentina/Mendoza',

  // America/Indiana — pre-2006 short forms
  'America/Fort_Wayne': 'America/Indiana/Indianapolis',
  'America/Indianapolis': 'America/Indiana/Indianapolis',
  'America/Knox_IN': 'America/Indiana/Knox',

  // America/Kentucky — pre-2006 short forms
  'America/Louisville': 'America/Kentucky/Louisville',

  // America — other legacy aliases
  'America/Shiprock': 'America/Denver', // Navajo Nation, NM
  'America/Ensenada': 'America/Tijuana', // Baja California, MX
  'America/Coral_Harbour': 'America/Panama', // Nunavut, CA
  'America/Atka': 'America/Adak', // Aleutian Islands, US

  // Atlantic — renamed canonical cities
  'Atlantic/Faeroe': 'Atlantic/Faroe', // Faroe Islands
  'Atlantic/Reykjavik': 'Africa/Abidjan', // Iceland — zone1970.tab groups IS under Africa/Abidjan

  // Pacific — renamed / consolidated
  'Pacific/Samoa': 'Pacific/Pago_Pago', // American Samoa
  'Pacific/Midway': 'Pacific/Pago_Pago', // Midway Islands
  'Pacific/Johnston': 'Pacific/Honolulu', // Johnston Atoll

  // Australia — legacy POSIX shorthand names
  'Australia/ACT': 'Australia/Sydney',
  'Australia/Canberra': 'Australia/Sydney',
  'Australia/NSW': 'Australia/Sydney',
  'Australia/North': 'Australia/Darwin',
  'Australia/Queensland': 'Australia/Brisbane',
  'Australia/South': 'Australia/Adelaide',
  'Australia/Tasmania': 'Australia/Hobart',
  'Australia/Victoria': 'Australia/Melbourne',
  'Australia/West': 'Australia/Perth',
  'Australia/LHI': 'Australia/Lord_Howe',
  'Australia/Yancowinna': 'Australia/Broken_Hill',

  // Etc — POSIX-style aliases mapped to canonical Etc/ zones
  UTC: 'Etc/UTC'
};
